<template>
  <div>
    <v-select
      :items="items"
      outlined
      chips
      multiple
      item-text="name"
      item-value="id"
      label="Välj moment att kopiera"
      v-model="selectedItems"
      return-object
    ></v-select>
  </div>
</template>

<script>
export default {
  name: 'TheCopyPasteElementList',

  props: {
    items: {
      type: Array,
      default: () => ([])
    }
  },

  data: () => ({
    selectedItems: JSON.parse(sessionStorage.getItem('byn4_course_elements')) || []
  }),

  watch: {
    selectedItems: {
      handler(newVal) {
        sessionStorage.setItem('byn4_course_elements', JSON.stringify(newVal))
        this.$emit('selected-items', newVal)
      },
      immediate: true
    }
  }
}
</script>